// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseToBeResumedPage_root__HNTtZ"};